// extracted by mini-css-extract-plugin
export var audioPlayer = "_tb-0";